import React from "react";
import { ListItem, Footer, List, FooterLink } from "@deere/ux.uxframe-react";
import { useUserLogin } from "./UserLogin";

export default function PdcFooter() {
    const [userInfo] = useUserLogin();
    return (
        <>
            {userInfo ? <Footer>
                <List className="nav">
                    <ListItem> Back To:</ListItem>
                    <ListItem>
                        <FooterLink href="http://sm.jdnet.deere.com/"> Home </FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href="http://www.deere.com/suppliercode"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Supplier Code of Conduct</FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href="https://www.deere.com/en/privacy-and-data/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Privacy &amp; Data
                        </FooterLink>
                    </ListItem>
                    <ListItem>
                        <FooterLink
                            href="https://www.deere.com/en/privacy-and-data/terms/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >Terms of Use
                        </FooterLink>
                    </ListItem>
                </List>
            </Footer> : null}
        </>
    );
}